import {
  AlertDialog as Dialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle
} from '@cutilei/ui'

/*
  Aviso ou confirmação, sobre o AlertDialog do @cutilei/ui, com as props de antes do Design
  System. A tela abre e fecha pelo `visible`.

  - Fecha pelo Esc ou pelos botões, como todo AlertDialog: não tem X nem fecha com clique fora.
  - O foco abre no botão de cancelar, ou no de confirmar quando ele está sozinho.
  - Confirmar chama `onConfirm` e depois `onClose`, uma vez cada. Muitas telas passam o mesmo
    handler nos dois; ele roda uma vez só, porque rodar duas vezes navegava duas vezes e desfazia
    o toggle das que usam `setX(prev => !prev)`.
  - `message` aceita texto ou JSX, inclusive com parágrafos: vai numa `div`.
*/
export default function AlertDialog({
  visible,
  title = 'Confirmar',
  message,
  dangerous = false,
  confirmText = 'Ok',
  cancelText = '',
  containerStyle = {},
  buttonStyle = {},
  onConfirm = () => {},
  onClose: handleClose = () => {}
}) {
  // A largura que as telas passavam vira mínima: o botão da lib cresce com o texto e não corta.
  const buttonWidth = buttonStyle
    ? {...buttonStyle, width: undefined, minWidth: buttonStyle.width ?? buttonStyle.minWidth}
    : undefined

  const handleConfirm = event => {
    // Sem isso o Radix fecharia sozinho e chamaria o onClose outra vez: quem fecha é a tela.
    event.preventDefault()
    onConfirm()
    if (handleClose !== onConfirm) handleClose()
  }

  return (
    <Dialog open={Boolean(visible)} onOpenChange={open => { if (!open) handleClose() }}>
      <AlertDialogContent style={containerStyle || undefined}>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div>{message}</div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          {cancelText && (
            <AlertDialogCancel style={buttonWidth}>
              {cancelText}
            </AlertDialogCancel>
          )}
          <AlertDialogAction
            destructive={dangerous}
            onClick={handleConfirm}
            style={buttonWidth}
          >
            {confirmText}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </Dialog>
  )
}
